import { Flex, Group, Pill, Text } from '@mantine/core';

import { GovEvaluationAnnex6CentralizedByIdButton } from '@/module/GovEvaluation/components/GovEvaluationAnnex6ByIdCentralizedButton';
import { GovEvaluationAnnex6CentralizedByIdMissingItemsButton } from '@/module/GovEvaluation/components/GovEvaluationAnnex6ByIdCentralizedMissingItemsButton';
import { GovEvaluationDomainArchiveButton } from '@/module/GovEvaluation/components/GovEvaluationDomainArchiveButton';
import { GovEvaluationFacultyArchiveButton } from '@/module/GovEvaluation/components/GovEvaluationFacultyArchiveButton';

import { Content } from '@/core/components';

import { useCurrentUser } from '@feature/security';

import { GovEvaluation } from './../model/GovEvaluationTypes';
import { GovEvaluationAnnex1Button } from './GovEvaluationAnnex1Button';
import { GovEvaluationAnnex6Button } from './GovEvaluationAnnex6Button';
import { GovEvaluationAnnex6CentralizedButton } from './GovEvaluationAnnex6CentralizedButton';

export interface EvaluationHeaderProps {
  evaluation: GovEvaluation;
}

export function GovEvaluationHeader({ evaluation }: EvaluationHeaderProps) {
  const { currentRole } = useCurrentUser();

  return (
    <Content type="full">
      <Flex
        justify="center"
        align="center"
        gap="4px"
      >
        <Text fw="500">{evaluation.title}</Text>
        <Pill bg={evaluation.open ? 'green' : 'red'}>{evaluation.open ? 'Deschisă' : 'Închisă'}</Pill>
      </Flex>
      {currentRole === 'UNIVERSITY_ADMIN' && (
        <Group>
          <GovEvaluationAnnex1Button evaluationId={evaluation.id} />
          <GovEvaluationAnnex6Button evaluationId={evaluation.id} />
          <GovEvaluationAnnex6CentralizedButton evaluationId={evaluation.id} />
          <GovEvaluationAnnex6CentralizedByIdButton evaluationId={evaluation.id} />
          <GovEvaluationAnnex6CentralizedByIdMissingItemsButton evaluationId={evaluation.id} />
          <GovEvaluationDomainArchiveButton evaluationId={evaluation.id} />
          <GovEvaluationFacultyArchiveButton evaluationId={evaluation.id} />
        </Group>
      )}
    </Content>
  );
}
